var _excluded = ["label", "options", "onSelect", "footerAction", "value", "description"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { noop } from 'lodash';
import { useState } from 'react';
import { SelectableDropdownMenu } from '../../../containers';
import { forwardRef } from '../../../utils';
import { _TableMenuTriggerHeaderCell } from '../_TableMenuTriggerHeaderCell';
/**
 * @private This is for internal use only. Please use `TableSelectHeaderCellProps` from `@melio/penny`.
 */
// eslint-disable-next-line @typescript-eslint/naming-convention

import { jsx as _jsx } from "react/jsx-runtime";

/**
 * @private This is for internal use only. Please use `Table.SelectHeaderCell` from `@melio/penny`.
 */
export var _TableSelectHeaderCell = forwardRef((_ref, ref) => {
  var _restProps$dataTesti;

  var {
    label,
    options,
    onSelect,
    footerAction,
    value,
    description
  } = _ref,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var [isMenuOpen, setIsMenuOpen] = useState(false);

  var handleSelect = item => {
    if (!value || item.value !== value) {
      onSelect(item.value);
    }
  };

  var selectedOption = options === null || options === void 0 ? void 0 : options.find(option => option.value === value);

  var trigger = /*#__PURE__*/_jsx(_TableMenuTriggerHeaderCell, _objectSpread(_objectSpread({
    "data-component": "_TableSelectHeaderCell",
    label: label,
    "data-testid": "table-select-cell" // TODO: remove empty `onClick`. It must be passed in order for the hover background color to show.
    // ticket - ME-452 - https://meliorisk.atlassian.net/browse/ME-452
    ,
    onClick: noop,
    isMenuOpen: isMenuOpen,
    description: description
  }, restProps), {}, {
    ref: ref
  }));

  var dropdownSelectableTestId = "".concat((_restProps$dataTesti = restProps['data-testid']) !== null && _restProps$dataTesti !== void 0 ? _restProps$dataTesti : 'table-select-header-cell', "-dropdown-selectable");
  var optionsWithIndex = options.map((option, index) => _objectSpread(_objectSpread({}, option), {}, {
    index
  }));
  return /*#__PURE__*/_jsx(SelectableDropdownMenu, {
    trigger: trigger,
    items: optionsWithIndex,
    onOpenChange: setIsMenuOpen,
    isOpen: isMenuOpen,
    dropdownTestId: dropdownSelectableTestId,
    onSelect: handleSelect,
    footer: footerAction && _objectSpread(_objectSpread({}, footerAction), {}, {
      type: 'naked',
      variant: 'secondary'
    }),
    selectedItemValue: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value,
    size: "large"
  });
});
_TableSelectHeaderCell.displayName = '_TableSelectHeaderCell';
//# sourceMappingURL=_TableSelectHeaderCell.js.map